/* Customima · Home: reenvía a Microsoft Clarity los eventos de la home que cm-home.js y cm-home-builder.js dejan en dataLayer.
   - Clarity solo graba si la visitante acepta las cookies de analítica (lo decide customima-clarity.js); mientras tanto
     los eventos esperan en la cola de window.clarity y, si no hay permiso, no salen nunca.
   - Embudo del recomendador: home_rec_0_visto → home_rec_1_persona → home_rec_2_recuerdo → home_rec_3_joya →
     home_rec_4_resultado → home_rec_5_clic_joya. El resto de clics van como home_<evento>.
   - Etiquetas para filtrar grabaciones y mapas de calor: pagina, rec_persona, rec_recuerdo, rec_joya, rec_producto. */
(function () {
  if (window.__cmhClarity) return;
  window.__cmhClarity = true;
  var c = window.clarity = window.clarity || function () { (window.clarity.q = window.clarity.q || []).push(arguments); };
  var FUNNEL = {
    recipient_click: 'home_rec_1_persona',
    recommender_grabado: 'home_rec_2_recuerdo',
    recommender_tipo: 'home_rec_3_joya',
    recommender_complete: 'home_rec_4_resultado',
    recommender_result_click: 'home_rec_5_clic_joya'
  };
  var OTHER = ['hero_cta_click', 'hero_promo_click', 'hero_image_click', 'hero_secondary_click', 'product_click', 'personalization_start',
    'category_click', 'help_click', 'review_interaction', 'review_product_click', 'faq_open', 'blog_click', 'final_cta_click', 'promo_cta_click',
    'promo_product_click', 'personalize_type_click', 'budget_filter', 'finder_tab_change'];
  var TAGS = { recipient_click: ['rec_persona', 'recipient'], recommender_grabado: ['rec_recuerdo', 'value'], recommender_tipo: ['rec_joya', 'value'], recommender_complete: ['rec_producto', 'product'] };
  var sent = {};

  function forward(o) {
    if (!o || typeof o !== 'object' || !o.event) return;
    var ev = o.event, name = FUNNEL[ev];
    if (ev === 'section_view') {
      if (o.section_id === 'para-quien') name = 'home_rec_0_visto';
      else if (/opiniones|cm_opiniones/.test(o.section_id || '')) name = 'home_opiniones_visto';
    }
    if (!name && OTHER.indexOf(ev) > -1) name = 'home_' + ev;
    if (!name) return;
    try {
      c('event', name);
      var t = TAGS[ev]; if (t && o[t[1]]) c('set', t[0], String(o[t[1]]).slice(0, 60));
      if (!sent[name]) { sent[name] = 1; c('set', 'home_paso_max', name); }
    } catch (e) {}
  }

  try { c('set', 'pagina', 'home-nueva-2026-09'); } catch (e) {}
  var dl = window.dataLayer = window.dataLayer || [];
  for (var i = 0; i < dl.length; i++) forward(dl[i]);
  var push = dl.push;
  dl.push = function () {
    for (var j = 0; j < arguments.length; j++) forward(arguments[j]);
    return push.apply(dl, arguments);
  };
})();
